// extracted by mini-css-extract-plugin
export default {"container":"Accordion_container__Dhm6C","accordion":"Accordion_accordion__ui60l","open":"Accordion_open__D5zOE","inner":"Accordion_inner__LbZAV","body":"Accordion_body__nLN66"};